import { EntityTemplateVariables } from '@tools/interfaces/template';
import { templateOrder, templateOrderItem } from './template-order-and-order-items';
import { getContactFieldsForEntity } from './template-contact';

export const templateEntry: EntityTemplateVariables = {
  fields: [
    {
      label: 'templates.entries.code.label',
      contentValue: '{{ entry.code }}',
      description: 'templates.entries.code.description',
    },
    {
      label: 'templates.entries.date.label',
      contentValue: '{{ entry.date | date("d/m/Y") }}',
      description: 'templates.entries.date.description',
    },
    {
      label: 'templates.entries.end_date.label',
      contentValue: '{{ entry.end_date | date("d/m/Y") }}',
      description: 'templates.entries.end_date.description',
    },
    {
      label: 'templates.entries.entries_number.label',
      contentValue: '{{ entry.entries_number }}',
      description: 'templates.entries.entries_number.description',
    },
    {
      label: 'templates.entries.total_credits.label',
      contentValue: '{{ entry.total_credits }}',
      description: 'templates.entries.total_credits.description',
    },
    {
      label: 'templates.entries.remaining_credits.label',
      contentValue: '{{ entry.remaining_credits }}',
      description: 'templates.entries.remaining_credits.description',
    },
    {
      label: 'templates.entries.comment.label',
      contentValue: '{{ entry.comment }}',
      description: 'templates.entries.comment.description',
    },
  ],
  related: [
    {
      relationName: 'contact',
      relationType: 'simple',
      label: 'templates.entries.contact.label',
      description: 'templates.entries.contact.description',
      fields: getContactFieldsForEntity('entry.'),
    },
    {
      relationName: 'entryCategory',
      relationType: 'simple',
      label: 'templates.entries.entry_category.label',
      description: 'templates.entries.entry_category.description',
      fields: [
        {
          label: 'templates.entry_categories.name.label',
          contentValue: '{{ entry.entryCategory.name }}',
          description: 'templates.entry_categories.name.description',
        },
      ],
    },
  ],
  relatedInLoop: [
    {
      relationName: 'orders',
      relationType: 'inLoop',
      label: 'templates.entries.orders.label',
      description: 'templates.entries.orders.description',
      blockStartValue: '{% for order in entry.orders %}',
      contentValue: '{# Add some order fields #}',
      blockEndValue: '{% endfor %}',
      fields: templateOrder.fields,
    },
    {
      relationName: 'orderItems',
      relationType: 'inLoop',
      label: 'templates.entries.order_items.label',
      description: 'templates.entries.order_items.description',
      blockStartValue: '{% for order in entry.orders %}\n{% for orderItem in order.orderItems %}',
      contentValue: '{# Add some orderItem fields #}',
      blockEndValue: '{% endfor %}\n{% endfor %}',
      fields: templateOrderItem.fields,
    },
  ],
};
